<template>
  <div class="container">
    <component :is="style">
      .pagination.pagination-primary .page-item.active > .page-link,
      .pagination.pagination-primary .page-item.active > .page-link:focus,
      .pagination.pagination-primary .page-item.active > .page-link:hover {
      background-color: {{ myTheme.customizeButton.backgroundColor }}; color:
      {{ myTheme.customizeButton.color }}; }
      .el-collapse-item__header.is-active{ color:
      {{ myTheme.primaryTextColor }}; }      
    </component>
    <header class="blur"></header>
    <main>
      <div class="row">
        <div class="left col-lg-4">
          <div class="photo-left image-container">
            <picture-input
              class="photo"
              ref="pictureInput"
              width="200"
              height="200"
              radius="50"
              accept="image/*"
              :hideChangeButton="true"
              size="10"
              :prefill="user.avatar"
              :alertOnError="false"
              :zIndex="102"
              :customStrings="{
                upload: `<p>${$t('uploader.upload')}</p>`,
                drag: $t('uploader.drag'),
                tap: $t('uploader.tap'),
                fileSize: $t('uploader.fileSize'),
                fileType: $t('uploader.fileType'),
              }"
              @change="onChange"
            >
            </picture-input>
          </div>
          <h4 class="name">{{ user.first_name }} {{ user.last_name }}</h4>
          <p class="info">{{ user.telephone_number }}</p>
          <p class="info">{{ user.email }}</p>
          <div class="stats row">
            <div class="stat col-xs-4" style="padding-right: 50px;">
              <p class="number-stat">
                {{ ordersCounter }}
              </p>
              <p class="desc-stat">{{ $tc("text.p_orders", ordersCounter) }}</p>
            </div>
            <div class="stat col-xs-4">
              <p class="number-stat">{{userReviews ? userReviews.length : 0}}</p>
              <p class="desc-stat">{{ $tc("text.p_reviews", userReviews ? userReviews.length : 0 ) }}</p>
            </div>
            <div class="stat col-xs-4" style="padding-left: 50px;">
              <p class="number-stat">{{ userCards ? userCards.length : 0 }}</p>
              <p class="desc-stat">{{ $tc("text.p_cards", userCards ? userCards.length : 0 ) }}</p>
            </div>
          </div>
          <p class="desc"
            v-html="`<strong>${$t('text.my_primary_address')} : </strong> ${helpers.generateFromatedAddress(user.primary_address)}`"
          ></p>
          <div class="desc">
            <!--social-logout v-if="getProviderName"
              class="login-social-account"
              :logout-label="getSocialLogoutButtonText"
              :icon="getSocialButtonIcon"
              @logout="logout"
              :provider="getProviderName"
              :isConnected="true"
              :is-web-view="helpers.IsWebView()"
            /-->
            <n-button :style="myTheme.customizeButton" @click="logout()"
              ><i class="k-icon-logout mr-1"></i>{{ $t('button.logout') }}
            </n-button>
          </div>
          
        </div>
        <div class="right col-lg-8">
          <tabs
            :itemStyle="myTheme.customizeButton"
            class="account"
            type="primary"
            :handleClick="true"
          >
            <tab-pane id="profile">
              <template slot="label">
                <i class="now-ui-icons k-icon-account"></i>
                {{ $t('text.profile') }}
              </template>
              <update-account @onDeleteAccount="hanleDeletingAccount"
                :user="user"
                :avatarUpdated="avatarUpdated"
              ></update-account>
            </tab-pane>

            <tab-pane id="Address">
              <template slot="label">
                <i class="now-ui-icons k-icon-home-outline"></i>
                <span>{{ $t('text.address') }}</span>
              </template>
              <user-address></user-address>
            </tab-pane>

            <tab-pane title="Orders" id="orders">
              <template slot="label">
                <i class="now-ui-icons k-icon-food-1"></i>
                <span>{{$t("text.orders")}}</span>
              </template>
              <previous-orders
                @getOrdersCounter="displayOrdersCounter"
              ></previous-orders>
            </tab-pane>
            <tab-pane id="reviews">
              <template slot="label">
                <i class="now-ui-icons k-icon-forkstar-outline"></i>
                <span>{{$t('text.reviews')}}</span>
              </template>
              <div v-if="userReviews && userReviews.length">
                <review-item
                  v-for="(review, index) in userReviews"
                  :item="review"
                  :key="index"
                ></review-item>
              </div>
              <div v-else>
                <empty-data
                  iconColor="#444"
                  :message="$t('empty.reviews')"
                  icon="k-icon-forkstar-outline"
                  textColor="#000"
                ></empty-data>
              </div>
            </tab-pane>
            <tab-pane id="myCards">
              <template slot="label">
                <i class="now-ui-icons k-icon-creditcard"></i>
                <span>{{$t('text.cards')}}</span>
              </template>

              <add-card :userCards="userCards"></add-card>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </main>
  </div>
</template>
<script>

import { UpdateAccount, PreviousOrders, UserAddress } from "@/views";
import { AddCard, ReviewItem, EmptyData } from "@/views/components";
import { FormGroupInput, Button, Tabs, TabPane } from "@/components";
import { helpers } from "@/utilities";
import { mapActions, mapState, mapGetters } from "vuex";
import router from "../router";

import PictureInput from "vue-picture-input";
export default {
  computed: {
    ...mapGetters(["isAuthenticated", "getProviderName"]),
    ...mapState({
      user: (state) => state.auth.user,
      business: (state) => state.business,
      userCards: (state) => state.userCards,
      userReviews: (state) => state.userReviews,
    }),
    getSocialLogoutButtonText(){
      return this.getProviderName == 'facebook' ? this.$t('button.logout_from_facebook') :
      this.getProviderName == 'google' ? this.$t('button.logout_from_google') : 
      this.getProviderName == 'apple' ? this.$t('button.logout_from_apple') : ''
    },
    getSocialButtonIcon(){
      return this.getProviderName == 'facebook' ? 'k-icon-facebook-1' : this.getProviderName == 'apple' ? 'k-icon-applepay': null
    }
  },
  components: {
    [FormGroupInput.name]: FormGroupInput,
    [Button.name]: Button,
    Tabs,
    TabPane,
    UpdateAccount,
    PreviousOrders,
    AddCard,
    ReviewItem,
    EmptyData,
    UserAddress,
    PictureInput,
  },
  name: "account",
  bodyClass: "account-page",
  data() {
    return {
      helpers,
      ordersCounter: 0,
      style: "style",
      avatarUpdated: false,
    };
  },

  methods: {
    ...mapActions([
      "logoutRequest",
      "getUserReviewsRequest",
      "fetchUserCardsRequest"
    ]),
    onChange(image) {
      if (image) {
        this.avatarUpdated = true;
        this.user.avatar = image;
      }
    },
    logout() {
      this.logoutRequest();
      router.push({name:'home'});
    },
    displayOrdersCounter(count) {
      this.ordersCounter = count;
    },
    hanleDeletingAccount(){
      const confirmOptions = {
        dangerouslyUseHTMLString: true, 
        confirmButtonText: "Yes, I Confirm",
        cancelButtonText: "Cancel",
        customClass:"wtf-confirm",
        confirmButtonClass: "w-50 py-3 el-button--danger",
        cancelButtonClass: "w-25 py-3",
        showClose:false,
        center: true,
        closeOnClickModal:false,
        type:"danger"
      }
      const self = this;
      this.$confirm('We are sorry you want to go. All data related to your account will be permanently deleted and will not be retrievable. To use What The Fork in the future you will have to set up a new account.', 'Are you sure?', 
      confirmOptions
      ).then(() => {
          this.DeleteUserAccount().then(()=>{
            this.logout()
          
          }).catch(() => {
            const alert_options = {
                html: true,
                okText: this.$t('button.ok'),
                animation: "fade",
                type: "basic",
                backdropClose: false,
                customClass: "confirm",
              };

              const alert_message =
                `<div><i class='k-icon-sad big-icon' style='color:
                ${self.staticColor.red }
                ' ></i></div><div class='dg-content-body-text'>${this.$t('generic_error.error_delete_account')}</div>`;
              self.$dialog.alert(alert_message, alert_options);
          });


         }).catch(() => {})
    }
  },
  created(){
    this.getUserReviewsRequest();
    this.fetchUserCardsRequest();
  },
  beforeMount() {
    if (!this.isAuthenticated) router.push("/login");
  },
};
</script>
<style scoped>
.container {
  max-width: 1250px;
  margin: -3px auto 30px;
  padding: 0 !important;
  width: 90%;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgba(0, 0, 0, 0.1);
}

header {
  background: #eee;
  background-image: url("~/img/header-blur.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 250px;
}

header i {
  position: relative;
  cursor: pointer;
  right: -96%;
  top: 25px;
  font-size: 18px !important;
  color: #fff;
}

@media (max-width: 800px) {
  header {
    height: 150px;
  }

  header i {
    right: -90%;
  }
}

main {
  padding: 20px 20px 0px 20px;
}

.left {
  display: flex;
  align-items: center;
  /*justify-content: center;*/
  flex-direction: column;
}

.name {
  margin-top: 20px;
  font-weight: 600;
  font-size: 18pt;
  color: #777;
}

.info {
  margin-top: -5px;
  margin-bottom: 5px;
  font-size: 11pt;
  color: #aaa;
}

.stats {
  margin-top: 25px;
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #ededed;
}

.number-stat {
  padding: 0px;
  font-size: 14pt;
  font-weight: bold;
  color: #aaa;
}

.desc-stat {
  margin-top: -15px;
  font-size: 10pt;
  color: #bbb;
}

.desc {
  text-align: center;
    margin: 15px 40px 16px 40px;
    color: #999;
    font-size: 11pt;
    padding-bottom: 20px;
  border-bottom: 1px solid #ededed;
}

.right {
  padding: 0 !important;
}

.nav-tabs > .nav-item > .nav-link {
  padding: 10px 13px;
}
.nav-tabs {
  border: 0;
  padding: 15px 0 !important;
}
</style>
